import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  catchError,
  map,
  Observable,
  switchMap,
  throwError,
  timeout,
} from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { Language } from '../../model/languages';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly REQUEST_TIMEOUT = 100000;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  private getHeaders(): HttpHeaders {
    return this.authService.getHeaders();
  }

  getLanguages(): Observable<Language[]> {
    const headers = this.getHeaders();
    const endpoint = `${environment.api}/v1/languages`;

    return this.http
      .get<{ success: boolean; data: Language[] }>(endpoint, { headers })
      .pipe(
        timeout(this.REQUEST_TIMEOUT),
        map((response) => {
          if (!response.success) {
            throw new Error('not return success');
          }
          return response.data;
        }),
        catchError(this.handleError('Error fetching languages')),
      );
  }

  setLanguage(languageId: number): Observable<boolean> {
    const headers = this.getHeaders();
    const params = { languageId: languageId.toString() };

    return this.http
      .patch<{
        success: boolean;
      }>(`${environment.api}/v1/partners/languages`, {}, { headers, params })
      .pipe(
        map((response) => response.success),
        timeout(this.REQUEST_TIMEOUT),
        catchError(this.handleError('Error setting language')),
      );
  }

  private handleError(operation: string) {
    return (error: any): Observable<never> => {
      console.error(`${operation}:`, error);
      return throwError(
        () => new Error('Something went wrong; please try again later.'),
      );
    };
  }
}